import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { SiteUrls } from '@tableau/shared-urls';
import { Messages } from '../../../codegen/Localize';
import { IDataAlertInfo } from '../../../ts/models/IDataAlertInfo';
import { Set } from '../../../ts/models/Set';
import { DataAlerts } from '../../../ts/resources/DataAlerts';
import { AddSelfToAlertsAction } from '../../../ts/services/AddSelfToAlertsAction';
import { RemoveSelfFromAlertsAction } from '../../../ts/services/RemoveSelfFromAlertsAction';
import { ResumeDataAlertsAction } from '../../../ts/services/ResumeDataAlertsAction';
import { DataAlertAddMe, DataAlertEdit, DataAlertRemoveMe, DataAlertResume } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { DataAlertMenuAction } from '../../actions/spaces/DataAlertMenuActions';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { ServiceLocator } from '../../ServiceLocator';

export function* handleAddMe(action: DataAlertMenuAction): SagaIterator {
  try {
    yield call(dataAlertAddMe, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function dataAlertAddMe(alerts: IDataAlertInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<AddSelfToAlertsAction>('AddSelfToAlertsAction')
      .addSelf(Set.fromIdItemArray(alerts), context);
}

export function* handleRemoveMe(action: DataAlertMenuAction): SagaIterator {
  try {
    yield call(dataAlertRemoveMe, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function dataAlertRemoveMe(alerts: IDataAlertInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<RemoveSelfFromAlertsAction>('RemoveSelfFromAlertsAction')
      .removeSelf(Set.fromIdItemArray(alerts), context);
}

export function* handleResume(action: DataAlertMenuAction): SagaIterator {
  try {
    yield call(dataAlertResume, action.items);

    const siteUrlName = yield select(SessionSiteSelectors.siteUrlName);
    directToVizWithAlert(siteUrlName, action.items[0]);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function dataAlertResume(alerts: IDataAlertInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ResumeDataAlertsAction>('ResumeDataAlertsAction')
      .resumeDataAlerts(Set.fromIdItemArray(alerts), context);
}

export function* handleEdit(action: DataAlertMenuAction): SagaIterator {
  try {

    const siteUrlName = yield select(SessionSiteSelectors.siteUrlName);
    directToVizWithAlert(siteUrlName, action.items[0]);

  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function directToVizWithAlert(siteUrlName: string, alert: IDataAlertInfo) {
   // Re-create siteUrls here because angular stuff needs url after the '#'
  // cannot use $location.path because that will strip parameters
  // Also see Defect 649311: Menu item "Actions/Edit Alert" does not work
  const siteUrls = new SiteUrls({siteUrlName});
  const url = ServiceLocator.get<DataAlerts>('DataAlerts').alertOnVizPath(alert, siteUrls);
  const location = ServiceLocator.get<ng.ILocationService>('$location');
  const context = ServiceLocator.getAngularActionContext();
  _.defer(() => context.scope.$applyAsync(() => location.url(url)));
}

export function* rootDataAlertMenuActionSaga(): SagaIterator {
  yield takeEvery(DataAlertAddMe, handleAddMe);
  yield takeEvery(DataAlertRemoveMe, handleRemoveMe);
  yield takeEvery(DataAlertResume, handleResume);
  yield takeEvery(DataAlertEdit, handleEdit);
}
